angular.module('natura').directive('pggLayertree', [ function() {
  return {
    restrict : "E",
    templateUrl : "assets/terkep/app/layertree/layertree.html",
    replace : true,
    transclude : true,
    scope : {
      map : "="
    },
    controller : "PggLayertreeController",
    controllerAs : "ctrl",
    bindToController : true,
    link : function(scope, element, attrs) {
      // vektor réteg eltávolítása, ha "terkep" a térkép típusa
      // TODO: ez így nagyon csúnya megoldás
      switch (attrs.type) {
      case "gazdalkodoi":
        break;
      default:
        var array = scope.layergroups[0].data;
        for (var i = 0; i < array.length; i++) {
          layer = array[i];
          if (layer instanceof ol.layer.Vector) {
            var index = array.indexOf(layer);
            if (index > -1) {
              array.splice(index, 1);
              scope.map.removeLayer(layer);
            }
          }
        }
        break;
      }
    },
  };
} ]);

angular.module('natura').provider("pggLayerTreeProvider", [ function() {
  /**
   * CONFIG
   */
  var config = {
    layerGroupTypes : {},
    layerGroups : []
  };

  this.$get = [ function() {
    /**
     * GETTERS AND SETTERS
     */
    var _getLayerGroupTypes = function() {
      return config.layerGroupTypes;
    };
    var _getLayerGroups = function() {
      return config.layerGroups;
    };
    var _setLayerGroups = function(layergroups) {
      config.layerGroups = layergroups;
    };

    /**
     * FUNCTIONS
     */
    var _setLayerGroupType = function(key, value) {
      config.layerGroupTypes[key] = value;
    };

    var _addLayerGroup = function(layergroup) {
      config.layerGroups.push(layergroup);
    };

    var _addLayerToLayerGroup = function(layer, layerGroupName) {
      for (var i = 0; i < config.layerGroups.length; i++) {
        if (config.layerGroups[i].label == layerGroupName) {
          config.layerGroups[i].data.push(layer);
          break;
        }
      }
    };

    var _getLayersFromLayerGroup = function(layerGroupName) {
      for (var i = 0; i < config.layerGroups.length; i++) {
        if (config.layerGroups[i].label == layerGroupName) {
          return config.layerGroups[i].data;
        }
      }
    };

    /**
     * RETURNS
     */
    return {
      getLayerGroupTypes : _getLayerGroupTypes,
      getLayerGroups : _getLayerGroups,
      setLayerGroups : _setLayerGroups,
      setLayerGroupType : _setLayerGroupType,
      addLayerGroup : _addLayerGroup,
      addLayerToLayerGroup : _addLayerToLayerGroup,
      getLayersFromLayerGroup : _getLayersFromLayerGroup
    };
  } ];
} ]);

angular.module('natura').controller(
    'PggLayertreeController',
    [
        '$scope',
        '$sce',
        '$http',
        'ngeoDecorateLayer',
        'pggLayerTreeProvider',
        function($scope, $sce, $http, ngeoDecorateLayer, pggLayerTreeProvider) {
          $scope.map = this.map;

          pggLayerTreeProvider.setLayerGroupType("baseLayers", "Alaptérképek");
          pggLayerTreeProvider.setLayerGroupType("overlays", "Fedvények");

          pggLayerTreeProvider.setLayerGroups([]);
          pggLayerTreeProvider.addLayerGroup({
            label : pggLayerTreeProvider.getLayerGroupTypes().overlays,
            data : [],
            visible : true
          });
          pggLayerTreeProvider.addLayerGroup({
            label : pggLayerTreeProvider.getLayerGroupTypes().baseLayers,
            data : [],
            visible : true
          });

          $scope.tooltips = {
            visibility : $sce.trustAsHtml('Láthatóság'),
            opacity : $sce.trustAsHtml('Átlátszóság'),
            legend : $sce.trustAsHtml('Jelmagyarázat'),
            moveUp : $sce.trustAsHtml('Réteg mozgatása<br />felfelé'),
            moveDown : $sce.trustAsHtml('Réteg mozgatása<br />lefelé')
          };

          $scope.layergroups = pggLayerTreeProvider.getLayerGroups();

          $scope.map.getLayers().forEach(function(layer) {
            ngeoDecorateLayer(layer);
            layer.showLegend = false;
            layer.showOpacity = false;
            if (layer.get("baseLayer")) {
              pggLayerTreeProvider.addLayerToLayerGroup(layer, pggLayerTreeProvider.getLayerGroupTypes().baseLayers);
            } else {
              pggLayerTreeProvider.addLayerToLayerGroup(layer, pggLayerTreeProvider.getLayerGroupTypes().overlays);
            }
          });

          this.toggleVisibility = function(layer) {
            /**
             * a fedvény, akkor egyszerű: kapcsolja be ha ki van kapcsolva és
             * kapcsolja ki ha be van kapcsolva
             */
            if (pggLayerTreeProvider.getLayersFromLayerGroup(pggLayerTreeProvider.getLayerGroupTypes().baseLayers)
                .indexOf(layer) == -1) {
              if (!layer.getVisible()) {
                layer.setVisible(true);
              } else {
                layer.setVisible(false);
              }
            } else {
              /**
               * ha alaptérkép, akkor bonyolultabb egyszerre csak egy lehet
               * bekapcsolva belőle.
               */
              if (!layer.getVisible()) {
                angular.forEach(pggLayerTreeProvider
                    .getLayersFromLayerGroup(pggLayerTreeProvider.getLayerGroupTypes().baseLayers), function(lyr) {
                  if (layer == lyr) {
                    lyr.setVisible(true);
                  } else {
                    lyr.setVisible(false);
                  }
                });
              }
            }
          };

          this.getLegendGraphicUrl = function(layer, index) {
            var source = layer.getSource();
            var url = source.getUrls()[0];
            var layers = source.getParams().LAYERS;
            var getLegendGraphicUrl = url + "&service=WMS&request=GetLegendGraphic&format=image/png&LEGEND_OPTIONS=forceLabels:on&layer=" + layers.split(',')[index];
            return getLegendGraphicUrl;
          };

          this.toggleExpand = function(layergroup) {
            if (layergroup.visible) {
              layergroup.visible = false;
            } else {
              layergroup.visible = true;
            }
          };

          this.getShowLegend = function(layer) {
            return layer.showLegend;
          };

          this.toggleLegend = function(layer) {
            if (layer.showLegend) {
              layer.showLegend = false;
            } else {
              layer.showLegend = true;
            }
          };

          this.getShowOpacity = function(layer) {
            return layer.showOpacity;
          };

          this.toggleOpacity = function(layer) {
            if (layer.showOpacity) {
              layer.showOpacity = false;
            } else {
              layer.showOpacity = true;
            }
          };

          this.moveLayer = function(layer1, layer2) {
            var z1 = layer1.getZIndex();
            var z2 = layer2.getZIndex();
            layer1.setZIndex(z2);
            layer1.zIndex = z2;
            layer2.setZIndex(z1);
            layer2.zIndex = z1;
          };

        } ]);
